module.exports = __webpack_public_path__ + "img/dea-formazione-ico-la-scuola-e-2023.37720b6c.svg";